import state from '../initialState';

const initialState = {
  ...state,
  tokens: {},
  message: '',
};

export default initialState;
